import React from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="relative bg-background text-foreground font-sans antialiased min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main className="min-h-screen">
        <section className="relative py-20 md:py-24">
          <div className="container relative mx-auto px-3 sm:px-4 lg:px-6 max-w-3xl">
            <h1 className="font-display text-4xl md:text-5xl font-extrabold leading-tight mb-6">Terms of Service</h1>
            <div className="prose prose-invert max-w-none">
              <p>
                Welcome to <strong>Paokhum</strong>. By using our website and services, you agree to these simple terms:
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Use of Services</h2>
              <p>
                We deliver our work on a best-effort basis. Any content or access you provide must be yours to use.<br />
                For paid projects, milestones and deliverables will always be agreed in writing.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Liability</h2>
              <p>
                We work hard to ensure reliability and performance, but we can't be held responsible for indirect or consequential losses.<br />
                If something goes wrong, just reach out—we'll do our best to make it right.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Contact</h2>
              <p>
                Have questions about these terms? Call us at <a className="font-bold" href="tel:+919774477416"><strong>+91 9774477416</strong></a>.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfServicePage;

